firebird.directive('presenterGreenroomTimeNotification', [
    'templateCache',
    'helperService',
    function (templateCache, helperService) {
        return {
            restrict: 'E',
            template: templateCache.getTemplate(
                helperService.getRedesignPathPrefix() + 'presenter-greenroom-time-notification.html'
            ),
            link: function (scope, element, attrs, ngCtrl) {}
        };
    }
]);
